enum AllocationRoutes {
  Main = '/allocation/:tab',
}

export default AllocationRoutes
